import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgba(252, 252, 252, 1);
  position: fixed;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border: 1px solid #999999;
  width: 100%;
  bottom: 0;
  height: 88px;
  padding: 0px 50px 0px 50px;
  justify-content: space-between;
  align-items: center;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const Text = styled.h2`
  font-size: 14px;
  color: #4D4D4D;
`;